const allDetails = document.querySelectorAll(".hotspots-card-wrapper .card-media details");

allDetails.forEach((detail) => {
    detail.addEventListener("toggle", () => {
        if (detail.open) {
        allDetails.forEach((el) => {
            if (el !== detail && el.open) {
            el.removeAttribute("open");
            }
        });
        }
    });
});